import { makeObservable, observable, flow, action } from "mobx";
import { toast } from "sonner";

import { api } from "@/lib/services";
import { ApiRoutes } from "@/lib/routes";

export default class SelectedActivitySetStore {
  visible = false;
  loading = false;
  activitySet = null;
  activitySetId = null;
  error = null;

  constructor(parentStore) {
    makeObservable(this, {
      visible: observable,
      loading: observable,
      activitySet: observable,
      activitySetId: observable,
      error: observable,
      show: action,
      toggle: action,
      load: flow,
    });

    this.parentStore = parentStore;
  }

  show(activitySetId) {
    this.activitySetId = activitySetId;
    this.activitySet = null;
    this.error = null;
    this.visible = true;
    this.load();
  }

  toggle(open) {
    this.visible = open;
    if (!open) {
      this.activitySet = null;
      this.activitySetId = null;
      this.error = null;
    }
  }

  *load() {
    if (!this.activitySetId) return { success: false };
    try {
      this.loading = true;
      this.error = null;
      const response = yield api.get(ApiRoutes.forActivitySet(this.activitySetId));
      if (response.status === 200) {
        this.activitySet = response.data;
        return { success: true, data: response.data };
      }
      throw new Error("Unexpected status code");
    } catch (e) {
      this.error = e;
      toast.error("Error loading activity set", {
        description: e?.response?.data?.message || "Unexpected error, please try again later.",
      });
      return { success: false, error: e };
    } finally {
      this.loading = false;
    }
  }
}
